import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setTheme } from "../../../redux/theme";

const PopupChangeTheme = ({
    openPopupChangeTheme,
    setOpenPopupChangeTheme,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { theme } = useSelector((state) => state?.theme);

    const handleSetTheme = (value) => {
        dispatch(setTheme(value));
    };

    return (
        <div
            className={`components-popupchangeTheme ${
                openPopupChangeTheme ? "active" : ""
            }`}
        >
            <div className="box">
                <div
                    className="close"
                    onClick={() => setOpenPopupChangeTheme((prev) => !prev)}
                >
                    <img src="/images/close3.svg" alt="" />
                </div>
                <div className="title"> {t("header.Select theme")}</div>
                <div className="items">
                    <div
                        className={`item ${theme === "light" ? "active" : ""}`}
                        onClick={() => handleSetTheme("light")}
                    >
                        <div className="top">
                            <div className="radio">
                                <span></span>
                            </div>
                            {t("header.Light")}
                        </div>
                        <div className="image">
                            <img src="/images/theme1.svg" alt="" />
                        </div>
                    </div>
                    <div
                        className={`item ${theme === "dark" ? "active" : ""}`}
                        onClick={() => handleSetTheme("dark")}
                    >
                        <div className="top">
                            <div className="radio">
                                <span></span>
                            </div>
                            {t("header.Dark")}
                        </div>
                        <div className="image">
                            <img src="/images/theme2.svg" alt="" />
                        </div>
                    </div>
                    <div
                        className={`item ${
                            theme === "madness" ? "active" : ""
                        }`}
                        onClick={() => handleSetTheme("madness")}
                    >
                        <div className="top">
                            <div className="radio">
                                <span></span>
                            </div>
                            {t("header.Madness")}
                        </div>
                        <div className="image">
                            <img src="/images/theme3.svg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopupChangeTheme;
